import { render, staticRenderFns } from "./Schools.html?vue&type=template&id=4526f48f&scoped=true&external"
import script from "./Schools.js?vue&type=script&lang=js&external"
export * from "./Schools.js?vue&type=script&lang=js&external"
import style0 from "./Schools.vue?vue&type=style&index=0&id=4526f48f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4526f48f",
  null
  
)

export default component.exports